export enum QG_STATE {
    READY = 'ready',
    RECORDING = 'recording',
    PAUSED = 'paused',
    PROCESSING = 'processing',
    ERROR = 'error',
}

export enum QG_STOP_RECORDING_STATE {
    OK = 'ok',
    EMPTY = 'empty',
    ERROR = 'error',
}

export type dimensionsType = {
    innerHeight?: number
    innerWidth?: number
    outerHeight?: number
    outerWidth?: number
}

export type QG_STATE_UNION = `${QG_STATE}`
